<template>
  <div>
    <div :class="styles.FORM.FORM_GROUP">
      <label>
        Disable by role setting?
        <input type="checkbox" v-model="control.disableByRoleSetting">
      </label>
    </div>
    <div :class="styles.FORM.FORM_GROUP">
      <label>
        Max size (in KBytes - 0 for unlimited)
      </label>
      <input type="text" :class="styles.FORM.FORM_CONTROL" v-model="control.maxSize">
    </div>
    <div :class="styles.FORM.FORM_GROUP">
      <label>
        Allowed extension
      </label>
      <select :class="styles.FORM.FORM_CONTROL"
              v-model="control.allowedExtension">

        <option v-for="item in listReturnTypes"
                :key="item.val"
                :value="item.val"
                v-text="item.description">
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import {BaseControlConfigSkeleton} from 'v-form-builder';


export default {
  name: 'FileUploadConfigView',
  extends: BaseControlConfigSkeleton,
  data: () => ({
    listReturnTypes: [
      {val: 'application/pdf', description: 'PDF'},
      {val: 'image/jpeg', description: 'JPEG'},
      {val: 'image/png', description: 'PNG'},
    ],
  }),
};
</script>

<style scoped>

</style>
